import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${props => props.padding};
`;

const AmpelmannLogo = (props) => (
  <LogoContainer {...props}>
    <img src="/assets/logo.png" width={props.size} height={props.size} alt="Ampelmann Logo" />
  </LogoContainer>
);

AmpelmannLogo.propTypes = {
  padding: PropTypes.string,
  size: PropTypes.number
};

AmpelmannLogo.defaultProps = {
  size: 60
};

export default AmpelmannLogo;
